import {gsap, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class TextAppear {
	static init() {
		const items = document.querySelectorAll("[data-text-appear]");

		this.splitTexts= [];

		items.forEach(elem => {
			const innerSplit = new SplitText(elem, {
				type: "lines",
				linesClass: "split-inner"
			});

			const outerSplit = new SplitText(elem, {
				type: "lines",
				linesClass: "split-outer"
			});
			this.splitTexts.push(outerSplit);
			this.splitTexts.push(innerSplit);

			const delay = elem.dataset.textAppearDelay ?? 0; // Utilisez l'attribut HTML `data-aos-delay`

			const splitTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: elem,
					start: "top 90%",
				},
			});

			splitTimeline.set(elem, {
				visibility: 'visible'
			});

			splitTimeline.from(innerSplit.lines, {
				delay: parseFloat(delay),
				duration: 1,
				yPercent: 150,
				ease: "power1.ease",
				stagger: 0.15,
				autoAlpha: 0
			});
		});

		GlobalVariables.resizeCallbacks.push(this);
	}

	static resize() {
		this.splitTexts.forEach(item => {
			item.revert();
		});
	}
}
